<template>
  <div class="container">
    <div class="rightListOne">
          <div class="leftListOne_top">
            <span class="leftListOne_top_text">救援能力</span>
          </div>
          <div class="rightListOneCon">
              <div class="rightListOneCon_list">
                  <img src="@/assets/images/life.png" alt="" class="lifeImg animate__animated  animate__pulse animate__slower 5s animate__infinite infinite" />
                  <div class="rightListOneCon_list_Rt">
                    <span class="rtltone_list_Rt_tit">生活物资</span>
                    <span class="rtltone_list_Rt_num">{{IndexDataList.rescueLiveGoods}}<span class="rtltone_list_Rt_dant">件</span> </span>
                  </div>
              </div>
              <div class="rightListOneCon_list">
                  <img src="@/assets/images/rescue.png" alt="" class="lifeImg animate__animated  animate__pulse animate__slower 5s animate__infinite infinite" />
                  <div class="rightListOneCon_list_Rt">
                    <span class="rtltone_list_Rt_tit">救援物资</span>
                    <span class="rtltone_list_Rt_num">{{IndexDataList.rescueHelpGoods}} <span class="rtltone_list_Rt_dant">件</span> </span>
                  </div>
              </div>
              <div class="rightListOneCon_list">
                  <img src="@/assets/images/fulltime.png" alt="" class="lifeImg animate__animated  animate__pulse animate__slower 5s animate__infinite infinite" />
                  <div class="rightListOneCon_list_Rt">
                    <span class="rtltone_list_Rt_tit">专职救援人员</span>
                    <span class="rtltone_list_Rt_num">{{IndexDataList.rescueDutyMen}} <span class="rtltone_list_Rt_dant">人</span> </span>
                  </div>
              </div>
              <div class="rightListOneCon_list">
                  <img src="@/assets/images/society.png" alt="" class="lifeImg animate__animated  animate__pulse animate__slower 5s animate__infinite infinite" />
                  <div class="rightListOneCon_list_Rt">
                    <span class="rtltone_list_Rt_tit">社会志愿者</span>
                    <span class="rtltone_list_Rt_num">{{IndexDataList.rescueSocietyMen}}<span class="rtltone_list_Rt_dant">人</span> </span>
                  </div>
              </div>
              <div class="rightListOneCon_list">
                  <img src="@/assets/images/firefighting.png" alt="" class="lifeImg animate__animated  animate__pulse animate__slower 5s animate__infinite infinite" />
                  <div class="rightListOneCon_list_Rt">
                    <span class="rtltone_list_Rt_tit">消防车 </span>
                    <span class="rtltone_list_Rt_num">{{IndexDataList.rescueTruck}} <span class="rtltone_list_Rt_dant">辆</span> </span>
                  </div>
              </div>
              <div class="rightListOneCon_list">
                  <img src="@/assets/images/car.png" alt="" class="lifeImg animate__animated  animate__pulse animate__slower 5s animate__infinite infinite" />
                  <div class="rightListOneCon_list_Rt">
                    <span class="rtltone_list_Rt_tit">救援车辆 </span>
                    <span class="rtltone_list_Rt_num">{{IndexDataList.rescueCar}}<span class="rtltone_list_Rt_dant">辆</span> </span>
                  </div>
              </div>
          </div>
        </div>
        <div class="rightListOne">
          <div class="leftListOne_top">
            <span class="leftListOne_top_text">2023年灾害调查及危险性评估</span>
          </div>
          <div class="rightTwoList">
            <div class="rightTwoList_lf">
                <div class="pie"></div>
            </div>
            <div class="rightTwoList_rt">
              <div class="rightTwoList_rt_tit">
                  <span style="padding-left:10%;">地质灾害</span>
              </div>
              <span class="rightTwoList_rt_con">灾害频率 
                <span class="rightTwoList_rt_con_num">
                  <animate-number ref="myNum17" from="0" v-if="IndexDataList.estimateRate&&IndexDataList.estimateRate>0"  :to="IndexDataList.estimateRate" :key="IndexDataList.estimateRate"  duration="3000"  ></animate-number>
                  <span v-else>0</span>
                </span>
               次</span>
              <span class="rightTwoList_rt_con">灾害等级 
                <span class="rightTwoList_rt_con_num">
                  <animate-number ref="myNum18" from="0" v-if="IndexDataList.estimateLevel&&IndexDataList.estimateLevel>0" :to="IndexDataList.estimateLevel" :key="IndexDataList.estimateLevel"   duration="3000" ></animate-number>
                  <span v-else>0</span>
                </span> 
              级</span>
              <span class="rightTwoList_rt_con">人员伤亡 
                <span class="rightTwoList_rt_con_num">
                  <animate-number ref="myNum19" from="0" v-if="IndexDataList.estimateHurt&&IndexDataList.estimateHurt>0" :to="IndexDataList.estimateHurt" :key="IndexDataList.estimateHurt"   duration="3000"  ></animate-number>
                  <span v-else>0</span>
                </span> 
              例</span>
              <span class="rightTwoList_rt_con">直接经济损失 
                <span class="rightTwoList_rt_con_num">
                  <animate-number ref="myNum" from="0" v-if="IndexDataList.estimateLoss&&IndexDataList.estimateLoss>0" :to="IndexDataList.estimateLoss" :key="IndexDataList.estimateLoss"   duration="3000" ></animate-number>
                  <span v-else>0</span>
                </span> 
              亿元</span>
            </div>
          </div>
        </div>
        <div class="rightListOne">
          <div class="leftListOne_top">
            <span class="leftListOne_top_text">历史灾害<span class="leftListOne_top_more" @click="Lsqymore">更多》</span></span>
          </div>
          <div class="rightListThree" style="overflow:hidden;margin-top:0.6vw;height:13.5vw;">
            <vue-seamless-scroll :data="disasterHistoryList"  :class-option="optionSetting">
                <div class="rightListThree_list" v-for="(item,index) in disasterHistoryList" :key="index">
                    <div class="rightListThree_list_lf">
                        {{item.disasterRange}}
                    </div>
                    <div class="rightListThree_list_rt">
                        <span class="rightListThree_list_rt_tit">
                            {{item.disasterTypeName}}
                            <span class="rightListThree_list_rt_time" id="myElement">{{item.happenDate}}</span>
                        </span>
                        <span class="rightListThree_list_rt_txt">
                          {{item.remark}}
                        </span>
                    </div>
                </div>
              </vue-seamless-scroll>
          </div>
        </div>
      <el-dialog
        title=""
        :visible.sync="dialogVisibleLsqy"
        width="70%"
        top="7vh"
        :append-to-body="true">
        <div class="shopTc">
            <span class="shopTc_tit">历史灾害 <i class="el-icon-circle-close shopTc_show" @click="shopShowClose"></i> </span>
            <div class="shopTc_con" style="margin-bottom:1vw;">
              <span class="shopTc_zttit">灾害类型</span>
              <el-select v-model="valueLa" @change="changeFxLa" clearable placeholder="请选择">
                <el-option
                  v-for="item in optionsfxLa"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  >
                </el-option>
              </el-select>
              <span class="shopTc_zttit">所属区域</span>
              <el-input
                placeholder="请输入内容"
                v-model="inputfxTop"
                style="width:25%;"
                @input="inputfxLa"
                clearable>
              </el-input>
              <el-button style="margin-left:2%;" type="warning" size="small" icon="el-icon-refresh" @click="resetting2">重 置</el-button>
              <span class="zongji">总计 <span class="zongji_Num">{{total}}</span> 条</span>
            </div>
            <el-table
              :data="tableDataFx"
              height="485"
              style="width: 96%;margin:0 auto;">
              <el-table-column
                type="index"
                label="#"
                align="center"
                width="50">
              </el-table-column>
              <el-table-column
                prop="disasterTypeName"
                label="灾害类型"
                align="center"
                width="150">
              </el-table-column>
              <el-table-column
                prop="disasterRange"
                label="所属区域"
                align="center"
                width="150">
              </el-table-column>
              <el-table-column
                prop="remark"
                label="详细内容"
                width="740">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p style="width:500px">{{ scope.row.remark }}</p>
                        <div slot="reference">
                            <el-tag
                                size="medium"
                                style="cursor: pointer;width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                                >{{ scope.row.remark }}</el-tag>
                        </div>
                    </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                label="时间"
                align="center"
                width="130"
                >
                <template slot-scope="scope">
                 <span slot="reference" >{{scope.row.happenDate.substr(0, 10) }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="shopTc_bottom tccom">
              <el-pagination
                @size-change="handleSizefxChange"
                @current-change="handleCurrentfxChange"
                :current-page="current"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
        </div>
    </el-dialog>
  </div>
</template>
 
<script>
import { queryIndexData ,queryDisasterHistoryList, querySimpleDataListForDisasterType,queryDivisionInfo} from '@/api';
import "echarts-gl";
window._AMapSecurityConfig = {
    securityJsCode: '9717000b582173f89bc34178c30f8837',
}
export default {
  name: 'MyComponent',
  props:{
    filterList:Array,
  },
  data () {
    return {
      dialogVisibleLsqy:false,
      valueLa: '',
      inputTop:'',
      input2:'',
      currentPage4: 4,
      IndexDataList:'',
      disasterHistoryList:[],
      inputfxTop:'',
      current: 1,
      size:10,
      total:0,
      disasterType:0,
      tableDataFx:[],
      optionsfxLa:[],
    }
  },
  created(){
    this.queryIndexDataApi();
  },
   mounted() {
    
  },
  watch:{
    filterList(newVal,oldVal){
      let divId = newVal[0].id
      queryDivisionInfo(divId).then(res=>{
        this.IndexDataList = res.data.screenSettingDTO
        // this.init(this.IndexDataList);
      })
    }
  },
  computed:{
			optionSetting(){
				return{
					step: 0.3, // 数值越大速度滚动越快
					limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					autoPlay: true, // 是否自动滚动
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
				}
			},
		},
  methods:{
    resetting2(){
      this.valueLa = '';
      this.inputfxTop = '';
      this.inputfxLa();
      queryDisasterHistoryList({
        name:'',
        disasterType:0,
        current:1,
        size:10,
      }).then(res=>{
        this.tableDataFx = res.data.records
        this.total = res.data.total
      })
    },
    queryIndexDataApi(){
      queryIndexData().then(res=>{
        this.IndexDataList = res.data
        this.disasterHistoryList = res.data.disasterHistoryList
      })
    },
    querySimpleDataListForDisasterTypeApi(){
      querySimpleDataListForDisasterType().then(res=>{
        this.optionsfxLa = res.data
      })
    },
    Lsqymore(){
      this.dialogVisibleLsqy = true
      this.querySimpleDataListForDisasterTypeApi()
      queryDisasterHistoryList({
        name:'',
        disasterType:this.disasterType,
        current:this.current,
        size:this.size,
      }).then(res=>{
        this.tableDataFx = res.data.records
        this.total = res.data.total
      })
    },
    shopShowClose(){
      this.dialogVisibleShop = false
      this.dialogVisibleLsqy = false
    },
    changeFxLa(e){
      if (e=='') {
        this.disasterType = 0
      }else{
        this.disasterType = e
      }
      queryDisasterHistoryList({
        name:'',
        disasterType:this.disasterType,
        current:this.current,
        size:this.size,
      }).then(res=>{
        this.tableDataFx = res.data.records
        this.total = res.data.total
      })
    },
    handleSizefxChange(val) {
       this.size = val
         queryDisasterHistoryList({
          name:'',
          disasterType:this.disasterType,
          current:this.current,
          size:this.size,
        }).then(res=>{
          this.tableDataFx = res.data.records
          this.total = res.data.total
        })
    },
    handleCurrentfxChange(val) {
      this.current = val
      queryDisasterHistoryList({
        buildingInfoName:'',
        buildingTypeId:'',
        current:this.current,
        size:this.size,
        isBuildingType:this.isBuildingType,
      }).then(res=>{
        this.tableDataTwo = res.data.records
        this.total = res.data.total
      })
    },
    inputfxLa(val){
      queryDisasterHistoryList({
        name:val,
        disasterType:this.disasterType,
        current:this.current,
        size:this.size,
      }).then(res=>{
        this.tableDataFx = res.data.records
        this.total = res.data.total
      })
    },
  }
}
</script>

<style  scoped>
@import "@/assets/css/index.css";
@import "@/assets/css/left.css";
</style>